export default __webpack_public_path__ + "static/media/omitir.62f917b4.svg";